module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/404.png")
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#33312D",
      "margin-top": "40px"
    }
  }, [_vm._v("抱歉，您访问的页面不存在")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "70px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v("返回首页")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-5274a5e0"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/404.vue
// module id = 797
// module chunks = 1